import React from 'react'
import { SCORES, white } from '../constants'
import styled, { keyframes } from 'styled-components'
import RightClick from '../utils/rightClick'

const NumberStyle = styled.div`
  font-size: 15vh;
  text-align: center;
`

const NameStyle = styled.div`
  font-size: 4vh;
  text-align: center;
`

const ScoreRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`
const Pointer = styled.div`
  cursor: pointer;
`

const scale = keyframes`
  0% {
    transform: scale(1.0);
  }

  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1.0);
    
  }
`

const Sores = ({ increment, decrement, scores, fighter, winner }) => {
  const Card = styled.div`
    padding: 0 0 1em 0;
    width: 90%;
    background-color: ${fighter === white ? 'white' : '#1565c0'};
    color: ${fighter === white ? '#404040 ' : '#ffffffd6'};
    ${fighter === winner ? `animation: ${scale} 1s linear infinite` : ''};
    margin-top: 1em;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
  `

  const click = (event, fighter, type) => {
    event && event.preventDefault()
    decrement(fighter, type)
  }

  const score = type => {
    return (
      <RightClick onLongPress={event => click(event, fighter, type)}>
        <Pointer
          onClick={() => increment(fighter, type)}
          onContextMenu={event => click(event, fighter, type)}
        >
          <NumberStyle>{scores[type]}</NumberStyle>
          <NameStyle>{type}</NameStyle>
        </Pointer>
      </RightClick>
    )
  }

  return (
    <Card>
      <ScoreRow>
        {score(SCORES.IPPON)}
        {score(SCORES.WAZARI)}
        {score(SCORES.SHIDO)}
      </ScoreRow>
    </Card>
  )
}

export default Sores



// WEBPACK FOOTER //
// ./src/scoreboard/scores.jsx